import * as s from '~js/utils/selectors';
import * as c from '~js/utils/classes';

export class ContactForm {
  constructor(section) {
    this.container = section.container;
    this.closeButton = this.container.querySelector(s.selectors$s.formMessageClose);
    this.messageWrapper = this.container.querySelector(s.selectors$s.formMessageWrapper);

    if (this.messageWrapper) {
      this.hidePopups();
      this.closeFormMessage();
      this.autoHideMessage();
    }
  }

  hidePopups() {
    document.body.classList.add(c.classes$k.notificationVisible);
  }

  showPopups() {
    document.body.classList.remove(c.classes$k.notificationVisible);
  }

  closeFormMessage() {
    this.closeButton.addEventListener('click', this.closeMessage.bind(this));
  }

  closeMessage(e) {
    e.preventDefault();
    this.messageWrapper.classList.add(c.classes$k.hideDown);
    this.showPopups();
  }

  autoHideMessage() {
    setTimeout(() => {
      this.messageWrapper.classList.add(c.classes$k.hideDown);
      this.showPopups();
    }, 10000);
  }
}